import { Typography } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function StackedSubCat({ data }) {
  return (
    <div>
        <h2 className="chart-title">Graph By Sub-Category</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          barSize={40}
        >
          <XAxis dataKey="SubCategoryName" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="TotalCorrectAnswers" stackId="a" fill="#80ca9d" />
          <Bar dataKey="TotalWrongAnswers" stackId="a" fill="#ffc758" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
